import { render } from "./museumCourse.vue?vue&type=template&id=a4783c16&scoped=true"
import script from "./museumCourse.vue?vue&type=script&lang=js"
export * from "./museumCourse.vue?vue&type=script&lang=js"

import "./museumCourse.vue?vue&type=style&index=0&id=a4783c16&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4783c16"]])

export default __exports__